import { useQuery } from '@tanstack/react-query'

import { getWebinarList } from './useWebinarService'

export const useGetWebinarListQuery = (languageParam: string ) => {
  return useQuery({
    queryKey: ['webinars', languageParam],
    queryFn: () => getWebinarList(languageParam),
    enabled: !!languageParam,
  })
}
